// extracted by mini-css-extract-plugin
export default {"tupacGrid":"gj-z","tupacHeader":"hj-z","tupacHeader2":"ij-z","tupacMenu":"jj-z","tupacMenu2":"kj-z","tupacMain":"lj-z","tupacMain2":"mj-z"};